import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import getPath from 'lodash/get';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { LoadingWrapper, RowDivision } from '../../../../styles/styled';
import { DivisionLabel } from '../shared/styled-components';
import SoundcastSelector from './SoundcastSelector';
import DisplayRatings from './DisplayRatings';
import Overview from './Overview';
import Reviews from './Reviews';
import Loading from '../../../../components/Loading';
import { FloatingFlexiWrapper, RelativeContainer } from '../managed/styled';

const getLoadingOperations = operation => {
  return getPath(
    {
      'fetch-ratings-list': 'Loading Ratings...',
      'ratings-delete': 'Deleting the selected rating',
    },
    operation,
    'Loading...'
  );
};

const Ratings = () => {
  const [soundcast, setSoundcast] = useState({});
  const [loadingMsg, setLoadingMessage] = useState('');
  const { soundcastId = '' } = soundcast;
  const busy = useSelector(store => store.ratings.busy);
  const operation = useSelector(store => store.ratings.operation);
  const loading = getPath(busy, soundcastId, false);
  const onSoundcastChange = soundcast => setSoundcast(soundcast);
  const showLoader = loading || isEmpty(soundcast);

  useEffect(() => {
    if (!isEmpty(operation)) {
      setLoadingMessage(getLoadingOperations(operation));
    }
  }, [operation]);

  return (
    <RelativeContainer>
      {showLoader && (
        <LoadingWrapper float={true}>
          <Loading text={loadingMsg} align="center" size={50} fontSize={2} height={90} />
        </LoadingWrapper>
      )}
      <FloatingFlexiWrapper className="padding-20px">
        <div className="padding-bottom-20px">
          <div className="row">
            <div className="col-lg-11 col-md-12 col-sm-12 col-xs-12">
              <div className="title-medium">Ratings</div>
            </div>
          </div>
        </div>
        <RowDivision className="row">
          <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12">
            <DivisionLabel>Soundcast</DivisionLabel>
            <SoundcastSelectWrapper>
              <SoundcastSelector onSoundcastChange={onSoundcastChange} />
            </SoundcastSelectWrapper>
          </div>
        </RowDivision>
        <RowDivision className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <DivisionLabel>Overview</DivisionLabel>
            <Overview soundcast={soundcast} />
          </div>
        </RowDivision>
        <RowDivision className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <DivisionLabel>Settings</DivisionLabel>
            <DisplayRatings soundcast={soundcast} />
          </div>
        </RowDivision>
        <RowDivision className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <DivisionLabel>Reviews</DivisionLabel>
          </div>
        </RowDivision>
        <Reviews soundcast={soundcast} />
      </FloatingFlexiWrapper>
    </RelativeContainer>
  );
};

const SoundcastSelectWrapper = styled.div`
  width: 100%;
  display: inline-block;
`;

export default Ratings;
